import HomeRounded from '@mui/icons-material/HomeRounded'
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined'
import StoreMallDirectoryOutlined from '@mui/icons-material/StoreMallDirectoryOutlined'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import BarChartRounded from '@mui/icons-material/BarChartRounded'
import ViewInArOutlined from '@mui/icons-material/ViewInArOutlined'
import PersonOutlineRounded from '@mui/icons-material/PersonOutlineRounded'
import PedalBikeRounded from '@mui/icons-material/PedalBikeRounded'
import GroupsRounded from '@mui/icons-material/GroupsRounded'
import HeadsetMicOutlined from '@mui/icons-material/HeadsetMicOutlined'
import SettingsOutlined from '@mui/icons-material/SettingsOutlined'
import RecordVoiceOverOutlined from '@mui/icons-material/RecordVoiceOverOutlined'
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined'
import RestaurantMenuRounded from '@mui/icons-material/RestaurantMenuRounded'
import GridViewOutlined from '@mui/icons-material/GridViewOutlined'
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined'
import CampaignOutlined from '@mui/icons-material/CampaignOutlined'
import VolunteerActivismOutlined from '@mui/icons-material/VolunteerActivismOutlined'
import MapOutlined from '@mui/icons-material/MapOutlined'
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined'
import NotificationsNoneRounded from '@mui/icons-material/NotificationsNoneRounded'
import PercentRounded from '@mui/icons-material/PercentRounded'
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined'
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined'
import ShareOutlined from '@mui/icons-material/ShareOutlined'
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded'
import SpaceDashboardOutlined from '@mui/icons-material/SpaceDashboardOutlined'
import FastfoodOutlined from '@mui/icons-material/FastfoodOutlined'
import CategoryOutlined from '@mui/icons-material/CategoryOutlined'
import TuneRounded from '@mui/icons-material/TuneRounded'
import StarOutlineRounded from '@mui/icons-material/StarOutlineRounded'
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded'
import ScheduleRounded from '@mui/icons-material/ScheduleRounded'
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined'
import PlaceOutlined from '@mui/icons-material/PlaceOutlined'
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined'
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined'
import InsightsRounded from '@mui/icons-material/InsightsRounded'

// Sidebar icon per route name, in the style of the redesigned panel. Routes
// not listed here keep the SVG icon defined in routes.js.
const sidebarIcons = {
  Overview: HomeRounded,
  Vendors: StorefrontOutlined,
  Restaurants: StoreMallDirectoryOutlined,
  Orders: AssignmentOutlined,
  Reporting: BarChartRounded,
  'Restaurant Sections': ViewInArOutlined,
  Users: PersonOutlineRounded,
  Riders: PedalBikeRounded,
  Staff: GroupsRounded,
  'Customer Support': HeadsetMicOutlined,
  Configuration: SettingsOutlined,
  Influencers: RecordVoiceOverOutlined,
  'Customer Marketing': InsightsRounded,
  Coupons: LocalOfferOutlined,
  Cuisines: RestaurantMenuRounded,
  'Shop Types': GridViewOutlined,
  'Zone Spotlight': AutoAwesomeOutlined,
  'Restaurant Ads': CampaignOutlined,
  Tipping: VolunteerActivismOutlined,
  Zone: MapOutlined,
  Dispatch: LocalShippingOutlined,
  Courier: Inventory2Outlined,
  Notifications: NotificationsNoneRounded,
  'Commission Rates': PercentRounded,
  'Withdraw Requests': AccountBalanceWalletOutlined,
  Loyalty: CardGiftcardOutlined,
  Referral: ShareOutlined,
  'Back to Admin': ArrowBackRounded
}

// Store-level (/admin layout) sidebar, same icon family as the admin panel.
export const restaurantSidebarIcons = {
  Dashboard: SpaceDashboardOutlined,
  Profile: PersonOutlineRounded,
  Food: FastfoodOutlined,
  Category: CategoryOutlined,
  Orders: AssignmentOutlined,
  Option: TuneRounded,
  Ratings: StarOutlineRounded,
  Addons: AddCircleOutlineRounded,
  Timings: ScheduleRounded,
  Payment: PaymentsOutlined,
  Location: PlaceOutlined,
  Marketing: CampaignOutlined,
  Dispatch: LocalShippingOutlined,
  'Back to Admin': ArrowBackRounded
}

// Influencer panel (/influencer layout), same icon family again.
export const influencerSidebarIcons = {
  Home: HomeRounded,
  Orders: ReceiptLongOutlined,
  Wallet: AccountBalanceWalletOutlined,
  Profile: PersonOutlineRounded,
  'Bank Management': AccountBalanceOutlined,
  Settings: SettingsOutlined,
  'Back to Admin': ArrowBackRounded
}

export default sidebarIcons
